export default {"src":"/_next/static/media/visibility-off-v2.140f9086.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};